import { AUTH_LOGOUT, AUTH_REQUEST } from '../../store/mutations_type'

import { routerErrror } from '../route-navigation'

function login() {
  this.$refs.form.validate()
  if (this.$refs.form.validate()) {
    const username = this.username
    const password = this.password
    this.$store
      .dispatch(AUTH_REQUEST, { username, password })
      .then(() => {
        if (window.localStorage.getItem('url')) {
          this.$router
            .push(window.localStorage.getItem('url'))
            .catch(routerErrror)
        } else {
          // this.$router.push('/').catch(routerErrror)
        }
      })
      .catch(e => console.log(e))
  }
}

function logout() {
  this.$store
    .dispatch(AUTH_LOGOUT)
    .then(() => this.$router.push('/login').catch(routerErrror))
}

function loggedIn() {
  this.$store.state.status.login_required = false
  window.localStorage.setItem('url', this.$route.fullPath)
  this.$router.push('/login').catch(routerErrror)
}

export { login, logout, loggedIn }
